<template>
  <div class="login">
    <div class="loginBox">
      <div class="avatar">
        <img src='https://s3.bmp.ovh/2026/01/26/4rDoNVBU.png'/>
      </div>
      <!-- 校验四步骤:step2 -->
      <el-form :model="modelValue" :rules="rules" ref="loginFormRef" class="loginForm" label-width="70px">
        <!-- 校验四步骤:step3 -->
        <el-form-item prop="username" label="用户名">
          <!-- 校验四步骤:step4 -->
          <el-input v-model="modelValue.username" prefix-icon="iconfont icon-username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input v-model="modelValue.password" prefix-icon="iconfont icon-password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item class="btn">
          <el-button @click="onLogin" type="primary">确定</el-button>
          <el-button @click="onReset" type="info">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
export default {
  name: 'LoginPage',
  data () {
    return {
      loginObj: {
        name: 'admin',
        password: 123456
      },
      // 校验四步骤:step1
      modelValue: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // axios.get('/api/login', { params: this.loginObj })
    //   .then(res => {
    //     console.log('成功了:', res)
    //   })
    //   .catch(err => {
    //     console.log('失败了:', err)
    //   })
    // 不使用axios,直接使用this.$http
    // this.$http.get('/api/login', { params: this.loginObj })
    //   .then(res => {
    //     console.log('成功了:', res)
    //   })
    //   .catch(err => {
    //     console.log('失败了:', err)
    //   })
  },
  methods: {
    onLogin () {
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) {
          return false
        } else {
          console.log('表单数据:', this.modelValue)
          // 请求登录接口,将用户名和密码传递给后端进行校验
          // const res = await this.$http.get(`${this.$BASE_URL}/api/login`, { params: this.modelValue })
          // console.log('登录接口返回的数据:', res)
          // if (res.data.code === 200) {
          this.$message.success('登陆成功!')
          // 将token保存到sessionStorage中，用于后续的路由守卫判断是否登录
          // console.log('token:', res.data.data.token)
          // window.sessionStorage.setItem('token', res.data.data.token)
          window.sessionStorage.setItem('token', 'test-token-123')
          this.$router.push('./home')
          // } else {
          //   this.$message.error('登陆失败!')
          // }
        }
      })
    },
    onReset () {
      this.$refs.loginFormRef.resetFields()// 直接调用重置方法,封装在element-plus中的表单方法
    }
  }

}
</script>
<style scoped>
.login {
  background-color: darkcyan;
  height: 100vh;
}

.loginBox {
  width: 450px;
  height: 350px;
  background-color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
}

/* 头像样式 */
.avatar {
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 50%;
  border: 1px solid #eee;
  padding: 5px;
  box-shadow: 0 0 10px #dddddd;
  position: absolute;
  transform: translate(-15%, -15%);
}

.avatar img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #eee;
}

/* 表单样式 */
.btn {
  display: flex;
}

.loginForm {
  position: absolute;
  bottom: 30px;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
</style>
